import 'regenerator-runtime/runtime'

import DOMReady from './utils/DOMReady'
import blogSort from './modules/blog-sort'
import header from './modules/header'
import lazyLoad from './modules/lazy-load'
import lightbox from './modules/lightbox'
import modal from './modules/modal'
import productsSlider from './modules/products-slider'
import resetForm from './modules/reset-form'
import shopFilters from './modules/shop-filters'
import svgLoader from './modules/svg-loader'
import whatsApp from './modules/whatsapp'
import wishlist from './modules/wishlist'
import wishlistForm from './modules/wishlist-form'

// // Include css for webpack (for development only)
const css = require('../css/main.scss') // eslint-disable-line no-unused-vars

DOMReady(() => {
  blogSort.init()
  header.init()
  lazyLoad.init()
  lightbox.init()
  modal.init()
  productsSlider.init()
  resetForm.init()
  shopFilters.init()
  svgLoader.init()
  whatsApp.init()
  wishlist.init()
  wishlistForm.init()
})
